/**
 * Utility functions for cache management
 */

/**
 * Clears all mindshare and subnet related caches from localStorage
 * This ensures fresh data is fetched and prevents stale data from being used
 */
export const clearAllCaches = (): void => {
  if (typeof window !== 'undefined' && window.localStorage) {
    // Clear all mindshare-related cache items
    const keysToRemove: string[] = [];
    
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key && (
        key.includes('mindshare') || 
        key.includes('cache') || 
        key.includes('tensorpulse') ||
        key.includes('subnet') ||
        key.includes('history') ||
        key.includes('update') ||
        key.includes('allSubnets')
      )) {
        keysToRemove.push(key);
      }
    }
    
    // Remove keys in a separate loop to avoid issues with changing localStorage during iteration
    keysToRemove.forEach(key => {
      localStorage.removeItem(key);
    });
    
    console.log(`Cleared ${keysToRemove.length} cache items`);
  }
};

/**
 * Gets the correct subnet name, handling special cases
 * @param netuid The subnet ID
 * @param subnetNames The mapping of subnet IDs to names
 * @returns The correct subnet name
 */
export const getCorrectSubnetName = (netuid: number, subnetNames: Record<number, string>): string => {
  // Special case for subnet 63 to always use "Quantum"
  if (netuid === 63) {
    return "Quantum";
  }
  
  // Otherwise use the name from subnetNames or a default
  return subnetNames[netuid] || `Subnet ${netuid}`;
};